const contractAresLoanView = require("./contractAresLoanView/contractAresLoanView");
const contractEasyLoanWrapper = require("./contractEasyLoanWrapper/contractEasyLoanWrapper");
const contractEasyLoanApprovedTypeCWrapper = require("./contractEasyLoanApprovedTypeCWrapper/contractEasyLoanApprovedTypeCWrapper");
// const contractLoansAndMortgagesTypeCWrapper = require("./contractLoansAndMortgagesTypeCWrapper/contractLoansAndMortgagesTypeCWrapper");
const contractPayrollLoanView = require("./contractPayrollLoanView/contractPayrollLoanView");
const contractPreGrantedCreditView = require("./contractPreGrantedCreditView/contractPreGrantedCreditView");
const contractRetailLoanView = require("./contractRetailLoanView/contractRetailLoanView");
const loanModifyAssociatedAccountView = require("./loanModifyAssociatedAccountView/loanModifyAssociatedAccountView");
const loansMortgagesView = require("./loansMortgagesView/loansMortgagesView");
const loanMovementsView = require("./loanMovementsView/loanMovementsView");
const aresLoanMovementsView = require("./aresLoanMovementsView/aresLoanMovementsView");
const loanPartialAmortizationView = require("./loanPartialAmortizationView/loanPartialAmortizationView");
const loanRepaymentPlanView = require("./loanRepaymentPlanView/loanRepaymentPlanView");
const aresLoanRepaymentPlanView = require("./aresLoanRepaymentPlanView/aresLoanRepaymentPlanView");
const loanSettlementsView = require("./loanSettlementsView/loanSettlementsView");
const loanView = require("./loanView/loanView");
const aresLoanView = require("./aresLoanView/aresLoanView");
const payrollLoanRequestView = require("./payrollLoanRequestView/payrollLoanRequestView");
const loansForAresTypeUserView = require("./loansForAresTypeUserView/loansForAresTypeUserView");
const aresLoansMortgagesContractView = require("./aresLoansMortgagesContractView/aresLoansMortgagesContractView");
const aresLoansConfirmationView = require("./aresLoansConfirmationView/aresLoansConfirmationView");
 
module.exports = {
    contractAresLoanView,
    contractEasyLoanWrapper,
    contractEasyLoanApprovedTypeCWrapper,
    // contractLoansAndMortgagesTypeCWrapper,
    contractPayrollLoanView,
    contractPreGrantedCreditView,
    contractRetailLoanView,
    loanModifyAssociatedAccountView,
    loansMortgagesView,
    loanMovementsView,
    loanPartialAmortizationView,
    loanRepaymentPlanView,
    aresLoanRepaymentPlanView,
    loanSettlementsView,
    loanView,
    aresLoanMovementsView,
    aresLoanView,
    payrollLoanRequestView,
    loansForAresTypeUserView,
    aresLoansMortgagesContractView,
    aresLoansConfirmationView,
};
